import React from 'react';
import './tracking.css';
const TrackingDetails = ({ data, type }) => {
  const detail = data[0]?.attributes;
  console.log('type', type);
  return (
    <div className=''>
      <div className='container-details'>
        <div className='details-header'>Details:</div>
        <div className='details-content'>
          <div className='detail-item'>
            <strong>
              {type === 'ladingNo'
                ? 'Bill of lading'
                : type === 'containerId'
                ? 'Container Id'
                : 'Booking Number'}
              :
            </strong>{' '}
            {type === 'ladingNo'
              ? detail?.ladingNo
              : type === 'containerId'
              ? detail?.containerId
              : detail?.bookingNo}
          </div>

          <div className='detail-item'>
            <span>
              <strong>Origin:</strong>{' '}
            </span>
            {detail?.origin || ''}
          </div>
          <div className='detail-item'>
            <strong>Destination:</strong> {detail?.destination || ''}
          </div>
          {type !== 'containerId' && (
            <div className='detail-item'>
              <strong>On Board:</strong> {detail?.onBoardDate || ''}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackingDetails;
